module.exports = __webpack_public_path__ + "assets/img/img104.b592ecbf.png";